<template>
  <section class="popular">
    <div class="head">
      <h3>Часто используемые</h3>
      <span class="note">20 самых частых — обновляется само</span>
    </div>
    <p v-if="!events.length" class="empty">{{ emptyText }}</p>
    <div v-else class="body">
      <div class="cloud">
        <button
          v-for="row in events"
          :key="row.id"
          type="button"
          class="chip"
          :class="{ on: isOn(row) }"
          @click="onChip(row)"
        >
          <span class="name">{{ row.event }}</span>
          <span v-if="Number(row.uses) > 0" class="uses">{{ row.uses }}</span>
        </button>
      </div>
      <div v-if="multiple" class="actions">
        <button type="button" class="act" :disabled="!selectedCount" @click="emit('add')">Добавить в таблицу ({{ selectedCount }})</button>
        <button type="button" class="act ghost" :disabled="!selectedCount" @click="emit('clear')">Снять выбор</button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  events: { type: Array, default: () => [] },
  multiple: { type: Boolean, default: false },
  selected: { type: Array, default: () => [] },
  actionCount: { type: Number, default: null },
  emptyText: { type: String, default: 'Пока нет частых событий' },
})

const emit = defineEmits(['pick', 'toggle', 'add', 'clear'])

const selectedCount = computed(() => {
  if (props.actionCount != null) return props.actionCount
  return (props.selected || []).filter((id) => id != null).length
})

function isOn(row) {
  return (props.selected || []).some((id) => id === row.id)
}

function onChip(row) {
  if (props.multiple) emit('toggle', row)
  else emit('pick', row)
}
</script>

<style scoped>
.popular { min-width: 0; }
.head { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; margin-bottom: 10px; }
.head h3 { margin: 0; font-size: 13px; font-weight: 600; color: #14181f; }
.note { font-size: 12px; color: #98a0ae; white-space: nowrap; }
.empty { margin: 0; font-size: 12.5px; color: #98a0ae; }
.body { display: flex; flex-wrap: wrap; align-items: flex-start; gap: 10px 12px; }
.cloud { display: flex; flex-wrap: wrap; gap: 8px; flex: 1 1 240px; min-width: 0; }
.chip {
  display: inline-flex; align-items: center; gap: 6px; width: auto; max-width: 100%;
  border: 1px solid #e6e8ec; background: #fff; color: #14181f;
  border-radius: 999px; padding: 6px 12px; cursor: pointer;
  font-family: inherit; font-size: 12.75px; font-weight: inherit; line-height: 1.3;
}
.chip:hover { border-color: #d5d9e0; }
.chip.on { background: #eef0e6; border-color: #676B52; color: #676B52; }
.uses { font-size: 11px; font-weight: 500; color: #6b7383; }
.actions { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.act {
  border: 1px solid #d5d9e0; background: #fff; color: #14181f; border-radius: 999px;
  padding: 6px 12px; font-family: inherit; font-size: 12.75px; font-weight: 500; cursor: pointer;
}
.act:hover { border-color: #b9bfc9; }
.act.ghost { background: transparent; color: #6b7383; }
.act:disabled { opacity: .45; cursor: default; }
@media (max-width: 760px) {
  .note { display: none; }
  .chip, .act { min-height: 42px; }
}
</style>
